// extracted by mini-css-extract-plugin
export default {"addOns":"_3lNV8HiLNDNsb9Vf5t3lTv","title":"_2TvSXf0v2cGmIOePRxYvHD","widget":"_1AzSQw6ZHJBa7VUvgGRAT8"};